/* eslint-disable camelcase */
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { pageSelector } from 'selectors/page/pageSelector';
import superChatActions from 'ai/actions/superChatActions';
import { superChatSelector } from 'ai/selectors/superChatSelector';
import sdnApi from 'ai/services/sdn';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/EntryPoint/locales', 'AIChat');

const { entryPointPrompts } = sdnApi;

const PAGE = 'PDP';
const localization = createStructuredSelector({
    new: getTextFromResource(getText, 'new'),
    aiChatInputPlaceholderPdp: getTextFromResource(getText, 'aiChatInputPlaceholderPdp')
});

const functions = (dispatch, _ownProps) => ({
    fetchEntryPointPromptsPdp: async product => {
        const { currentSku, productDetails, parentCategory } = product || {};
        const { skuId } = currentSku;
        const { productId } = productDetails;
        const { categoryId } = parentCategory;

        return entryPointPrompts({ productId, skuId, categoryId, page: PAGE }).then(data => data);
    },
    handlePromptClick: (prompts, product) => {
        const { productId, currentSku } = product;

        const data = {
            entrypoint: 'PDP',
            products: [
                {
                    product_id: productId,
                    sku_id: currentSku.skuId
                }
            ]
        };

        dispatch(superChatActions.showSuperChat(true, prompts, data));
    }
});

const fields = createSelector(localization, pageSelector, superChatSelector, (locales, page, superChat) => {
    return {
        localization: locales,
        product: page?.product || {},
        chatName: superChat?.config?.meta?.try_chat_name || ''
    };
});

const withProductPageProps = wrapHOC(connect(fields, functions));

export {
    withProductPageProps, fields, functions
};
